export function Performance() {
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold text-slate-900">Performance</h1>
      <p className="text-sm text-slate-500">
        Response times, throughput, and resource utilization.
      </p>
      <div className="rounded-xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        <p className="text-slate-400">Performance data will appear here.</p>
      </div>
    </div>
  )
}
